// You can write more code here

import { waitUntil } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

export default class TurnIndicator extends Phaser.GameObjects.Image {
  constructor(
    scene: Phaser.Scene,
    x?: number,
    y?: number,
    texture?: string,
    frame?: number | string,
  ) {
    super(scene, x ?? 0, y ?? 0, texture || 'duel-ring', frame);

    this.scaleX = 4;
    this.scaleY = 4;

    /* START-USER-CTR-CODE */
    this.initialize();
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  async initialize() {
    this.setVisible(false);
    await waitUntil(this.scene.time, () =>
      this.scene.textures.exists('duel-ring'),
    );
    this.setTexture('duel-ring');
    this.setVisible(true);
    this.scene?.tweens.add({
      targets: this,
      alpha: 0.2,
      scale: 3.6,
      duration: 1500,
      yoyo: true,
      repeat: -1,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
